"use client"

import { useEffect } from "react"

import { Button } from "@/components/ui/button"

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <main className="grid min-h-screen place-items-center bg-background px-4 text-foreground">
      <div className="w-full max-w-xl rounded-[2rem] border border-border/70 bg-card p-8 text-center shadow-sm">
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-primary">Error</p>
        <h1 className="mt-4 font-heading text-4xl font-semibold tracking-tight">Something interrupted this page.</h1>
        <p className="mt-4 leading-7 text-muted-foreground">Try again, or return to a stable route while the issue is resolved.</p>
        <Button type="button" onClick={reset} className="mt-8 rounded-full">Try again</Button>
      </div>
    </main>
  )
}